React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
R = require 'ramda'
ReactBacon = require 'react-bacon'
OrderSummary = require './order-summary'

cx = require 'classnames'

feedbackStore = require 'stores/feedback'
restaurantStore = require "stores/restaurant"

Globalize = require 'globalize'
{ FormatDate, FormatMessage } = require 'react-globalize'

{ toLocalDateTime, parseDateTime, toMoney } = require '../../lib/utils'

Spinner = require 'app/common/spinner'

orderUnconfirmed = R.flip(R.contains)(['accepted', 'executing', 'missed'])

stateToText = (state) ->
  switch state
    when null then "order.state.loading"
    when 'accepted', 'executing', 'missed', 'confirmed', 'canceled', 'invoiced' then "order.state.#{state}"
    else "order.state.processing"

State = createReactClass
  displayName: 'State'
  props:
    order: PropTypes.object.isRequired

  mixins: [ReactBacon.BaconMixin]

  getInitialState: ->
    orderState: null
    restaurant:
      configuration:
        allow_time: true
      timezone:
        offset: 0

  componentDidMount: ->
    @plug feedbackStore.state, 'orderState'
    @plug restaurantStore.restaurant, 'restaurant'

  render: ->
    timeClass = cx "hidden": !@state.restaurant.configuration.allow_time
    noTimeClass = cx "hidden": @state.restaurant.configuration.allow_time

    <div className="panel panel-secondary panel-swiss panel-center">
      <div className="panel-heading"><FormatMessage>{stateToText(@state.orderState)}</FormatMessage></div>
      <div className="panel-body">
        <div className={timeClass}>
          { @renderContent() }
        </div>
        <div className={noTimeClass}>
          <span className="panel-info">
            <FormatMessage variables={service: @props.order.service.label}>order.meta.status.heading.notime</FormatMessage>
          </span>
        </div>
      </div>
    </div>

  renderContent: ->
    if !@state.orderState or (@props.order.time.id is 'ASAP' and orderUnconfirmed(@state.orderState))
      @renderWaiting()
    else
      @renderTimeInfo()

  renderWaiting: ->
    dateTime = parseDateTime(@props.order.time.value)

    <div>
      <span className="panel-info">
        <FormatMessage variables={service: @props.order.service.label}>order.meta.status.heading.waiting</FormatMessage>
      </span>
      <span className="">
        <FormatMessage>order.meta.status.info.waiting</FormatMessage>
        { @renderTime dateTime }
        <br />
        <FormatMessage>order.meta.status.info.waiting2</FormatMessage>
        <br />
        <Spinner size={18}/>
      </span>
    </div>

  renderTimeInfo: ->
    dateTime = parseDateTime(@props.order.time.value)
    <div>
      <span className="panel-info">
        <FormatMessage variables={service: @props.order.service.label}>order.meta.status.heading</FormatMessage>
      </span>
      <span className="panel-xxl">
        <FormatDate options={date:"medium"}>{dateTime}</FormatDate>
        <br/>
        {@renderTime(dateTime)}
      </span>
    </div>

  renderTime: (dateTime) ->
    if @state.restaurant.configuration.order_time_type == 'datetime'
      if -(new Date).getTimezoneOffset() != @state.restaurant.timezone.offset
        <span>
          <FormatDate options={time:"short"}>{dateTime}</FormatDate> <FormatDate options={raw:"Z"}>{dateTime}</FormatDate>
        </span>
      else
        <FormatDate options={time:"short"}>{dateTime}</FormatDate>

Confirmation = createReactClass
  displayName: 'Confirmation'
  props:
    order: PropTypes.object.isRequired

  render: ->
    <div className="panel panel-default panel-swiss panel-center">
      <div className="panel-heading">
        <FormatMessage>order.meta.confirmation.heading</FormatMessage>
      </div>
      <div className="panel-body">
        <span className="panel-xxl">{@props.order.code}</span>
      </div>
    </div>

Total = createReactClass
  displayName: 'Total'
  props:
    order: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  render: ->
    withDefault = R.defaultTo R.path(['totals', 'total'], @props.order.carts[0])
    <div className="panel panel-default panel-swiss panel-center">
      <div className="panel-heading"><FormatMessage>order.meta.total.heading</FormatMessage></div>
      <div className="panel-body">
        <span className="panel-xxl">{toMoney(withDefault(R.path(['totals', 'total'], @props.order)), @props.locale)}</span>
      </div>
    </div>

Reserved = createReactClass
  displayName: 'Reserved'
  props:
    order: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  active: ->
    @props.locale is 'en-KW' or @props.locale is 'ar-KW'

  render: ->
    return null if !this.active()
    fields = ['paymentid', 'result', 'auth', 'ref', 'tranid', 'postdate', 'trackid', 'amount']

    <div className="panel panel-default panel-swiss panel-center">
      <div className="panel-heading"><FormatMessage>order.meta.td.heading</FormatMessage></div>
      <div className="spread-container">
        { R.map @renderField, fields }
      </div>
    </div>

  renderField: (field) ->
    label = Globalize.formatMessage "order.meta.td.#{field}", ["0"]
    value = @props.order.reserved[field]
    <div className="spread">
      <span key={field}>{label}</span>
      <span key={"#{field}-value"}>{ value }</span>
    </div>


Favorite = createReactClass
  displayName: 'Favorite'
  props:
    order: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  onToggleFavorite: () ->
    feedbackStore.toggleFavorite @props.order, !@props.order.favorite

  render: ->
    panelClass = cx 'panel panel-important panel-center panel-favorites',
      active: @props.order.favorite
    label = if @props.order.favorite then "order.meta.remove_favorite" else "order.meta.mark_favorite"
    <div className={panelClass} onClick={@onToggleFavorite}>
      <div className="panel-body">
        <div>
          <div className="fav-icon"></div>
        </div>
        <strong>
          <FormatMessage>{label}</FormatMessage>
        </strong>
        { !@props.order.favorite &&
          <small className="panel-info">
            <FormatMessage>order.meta.favorite_description</FormatMessage>
          </small>
        }
      </div>
    </div>

Bonus = createReactClass
  displayName: 'Bonus'
  props:
    order: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  render: ->
    return null if @props.order.rewards.bucks == 0 || @props.order.rewards.points == 0

    <div className="panel panel-default panel-swiss panel-center">
      <div className="panel-heading"><FormatMessage>order.meta.bonus.heading</FormatMessage></div>
      <div className="panel-body">
        <div>
          <span className="panel-info"><FormatMessage>order.meta.bonus.points</FormatMessage></span>
          <span className="panel-xxl">{@props.order.rewards.points}</span>
          <span className="panel-info">
            <FormatMessage>order.meta.bonus.bucks</FormatMessage>
            <strong> {toMoney(@props.order.rewards.bucks, @props.locale)}</strong>
          </span>
        </div>
      </div>
    </div>


module.exports =
  State: State
  Confirmation: Confirmation
  Total: Total
  Bonus: Bonus
  Summary: OrderSummary
  Favorite: Favorite
  Reserved: Reserved
